import React from 'react';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ModalWithConstantPresence } from '@cp/ds/src/components/modalWithConstantPresence';
import { useClientWebRouteParams, useClientWebRouteProps } from '@cp/entities/clientWebRoutes';
import { useCloseCitySelectionModal, useIsCitySelectionOpen } from 'src/features/location';
import CitySelectionForm from 'src/features/location/ui/citySelectionForm/citySelectionForm';

export const CitySelection: React.FC = () => {
  const onClose = useCloseCitySelectionModal();
  const isOpen = useIsCitySelectionOpen();
  const { pageId } = useClientWebRouteParams();
  const pageProps = useClientWebRouteProps<ClientWebPage.Catalog>();
  const isCatalog = pageId === ClientWebPage.Catalog;
  const formProps = isCatalog
    ? { generateCityLinkProps: { page: ClientWebPage.Catalog, pageProps }, pageProps }
    : { generateCityLinkProps: { page: ClientWebPage.Home } };

  return (
    <ModalWithConstantPresence isActive={isOpen} onClose={onClose}>
      <CitySelectionForm onClose={onClose} {...formProps} />
    </ModalWithConstantPresence>
  );
};
